enum ScaleDialogFields {
	FORMAT = "format",
	WIDTH = "width",
	HEIGHT = "height",
	ORIENTATION = "orientation",
	MARGIN_TOP = "margin-top",
	MARGIN_BOTTOM = "margin-bottom",
	MARGIN_LEFT = "margin-left",
	MARGIN_RIGHT = "margin-right",
	PREVIEW = "preview",
	ASPECT_RATIO = "aspect-ratio",
	BOXES = "boxes",
	PAGERANGE = "pagerange",
}

export default ScaleDialogFields;